<script>
  import {
    ArrowUpIcon,
  } from "vue-feather-icons";
  import appConfig from "@/app.config";
  import axios from 'axios';
  import { EventBus } from "@/event-bus";
  
  // 초기세팅
  function initialState() {
    return {
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      fields: [
        {key: 'idx', label: 'ID', thClass: 'col-1 text-center font-size-11', tdClass: 'col-1 text-center'},
        {key: 'today', label: '날짜', thClass: 'col-1 text-center font-size-11', tdClass: 'text-center'},
        {key: 'ip', label: 'IP주소', thClass: 'text-center font-size-11', tdClass: 'col-1 text-center'},
        {key: 'time', label: '마지막 접속시간', thClass: 'col-2 text-center font-size-11', tdClass: 'text-center'},
        {key: 'country', label: '접속위치', thClass: 'col-4 text-center font-size-11', tdClass: 'text-center'},
        {key: 'queryNum', label: '접속시도', thClass: 'col-1 text-center font-size-11', tdClass: 'col-2 text-center'},
        {key: 'headers', label: '헤더정보', thClass: 'col text-center font-size-11', tdClass: 'text-center'},
        {key: 'isUser', label: '봇검출', thClass: 'col text-center font-size-11', tdClass: 'text-center'},
      ],
      weblogList: [],
    };
  }
  
  export default {
    components: {
      ArrowUpIcon
    },
    data() {
      return initialState();
    },
    props: {
      selectedMenu: {
        type: String,
      },
    },
    computed: {
      // 최근 7일간 접속 통계 (최근 날짜가 먼저오게 정렬하자)
      dailyVisitorStats() {
        if (!this.weblogList || this.weblogList.length === 0) return [];
        
        // 날짜별로 그룹핑 (IP주소 기준으로 중복 제거)
        // 각 날짜마다 별도의 Set을 사용하여 같은 날짜 내에서만 중복 제거
        const dateGroups = {};
        
        this.weblogList.forEach(item => {
          // 실사용자만 처리
          if (item.isBotDangerCountry == false && item.isBot == false && item.searchBotName == '') {
            if (item.today && item.ip) {
              // 날짜 형식 정규화 (YYYY-MM-DD, YYYY.MM.DD 등)
              let normalizedDate = String(item.today).replace(/\./g, '-'); // 점을 대시로 변경
              
              // 날짜별로 Set 초기화 (없으면 생성)
              if (!dateGroups[normalizedDate]) {
                dateGroups[normalizedDate] = new Set();
              }
              
              // 같은 날짜 내에서만 IP 중복 제거 (다른 날짜는 별도 Set이므로 중복 허용)
              dateGroups[normalizedDate].add(item.ip);
            }
          }
        });
        
        // 최근 7일 날짜 생성
        const last7Days = [];
        for (let i = 6; i >= 0; i--) {
          const date = new Date();
          date.setDate(date.getDate() - i);
          
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const dateStr = `${year}-${month}-${day}`; // YYYY-MM-DD
          
          // 날짜 표시용
          let displayDate = i === 0 ? '오늘' : `-${i}일전`;
          
          // 해당 날짜의 고유 IP 개수 찾기
          let count = 0;
          
          // 정확한 날짜 매칭 먼저 시도
          if (dateGroups[dateStr]) {
            count = dateGroups[dateStr].size;
          } else {
            // 다른 형식의 날짜 찾기 (YYYY.MM.DD 등)
            const matchedKey = Object.keys(dateGroups).find(key => {
              const normalizedKey = key.replace(/\./g, '-');
              return normalizedKey === dateStr || 
                    normalizedKey.includes(`${year}-${month}-${day}`) ||
                    key === `${year}.${month}.${day}`;
            });
            
            if (matchedKey) {
              count = dateGroups[matchedKey].size;
            }
          }
          
          last7Days.push({
            day: displayDate,
            date: dateStr,
            count: count
          });
        }
        
        return last7Days.sort((a, b) => new Date(b.date) - new Date(a.date));
      },
      
      // 7일간 전체 합계
      totalVisitorCount() {
        if (!this.dailyVisitorStats || this.dailyVisitorStats.length === 0) return 0;
        return this.dailyVisitorStats.reduce((sum, stat) => sum + stat.count, 0);
      }
    },
    mounted() {
    },
    created() {
      this.first()
      EventBus.$on("web-analytics", (val)=> {
        if (val=='listRefresh') {
          this.readWeblogList();
        }
      });
    },
    methods: {
      first() {
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
          // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
          if (this.login.level < 98) {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
            this.$router.push('/');
          } else {
            this.readWeblogList()
          }
        } else {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        }
      },
      readWeblogList() {
        try {
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_read_weblog_list',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_id": this.login.idx,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              this.weblogList = res.data.weblogList;
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.response) {
              this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            }
          })
        } catch (error) {
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        }
      },
      // 행 배경색 클래스 결정 (날짜별로 구분)
      getRowClass(item, type) {
        if (!item || type !== 'row') return '';
        if (!item.today) return 'bg-white';
        
        // 날짜별로 고유한 배경색을 위해 날짜 문자열 전체를 해시
        // 같은 날짜를 가진 행들은 같은 배경색을 가져야 함
        const dateStr = String(item.today);
        
        // 날짜 문자열의 문자 코드 합으로 해시 생성 (더 정확한 구분)
        let hash = 0;
        for (let i = 0; i < dateStr.length; i++) {
          const char = dateStr.charCodeAt(i);
          hash = ((hash << 5) - hash) + char;
          hash = hash & hash; // 32비트 정수로 변환
        }
        
        // 날짜 해시값을 기준으로 배경색 결정 (같은 날짜면 같은 색)
        // 절대값을 사용하여 음수 방지
        return Math.abs(hash) % 2 === 0 ? '' : 'bg-light';
      },
      // User Agent 문자열 파싱
      parseUserAgent(userAgent) {
        if (!userAgent) return null;
        
        try {
          const result = {
            browser: '',
            os: '',
            isBot: false,
            isBotDangerCountry: false,
            botName: ''
          };
          
          // 봇 감지 (먼저 봇인지 확인)
          const ua = userAgent.toLowerCase();
          
          if (ua.includes('yeti') || ua.includes('+https://naver.me/spd')) {
            result.isBot = true;
            result.botName = '네이버 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('googlebot')) {
            result.isBot = true;
            result.botName = '구글 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('bingbot') || ua.includes('msnbot')) {
            result.isBot = true;
            result.botName = '빙 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('slurp')) {
            result.isBot = true;
            result.botName = '야후 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('facebookexternalhit')) {
            result.isBot = true;
            result.botName = '페이스북 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('twitterbot')) {
            result.isBot = true;
            result.botName = '트위터 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('kakaobot')) {
            result.isBot = true;
            result.botName = '카카오 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('daumoa')) {
            result.isBot = true;
            result.botName = '다음 봇';
            result.isBotDangerCountry = false;
            return result;
          } else if (ua.includes('crawler') || ua.includes('spider') || ua.includes('bot') || ua.includes('scraper')) {
            // 기타 봇 (crawler, spider, bot 등의 키워드가 있지만 위에서 이미 체크한 봇이 아닌 경우)
            // 단, "compatible" 같은 단어가 있으면 일반 브라우저일 수 있으므로 더 정확한 패턴 확인 필요
            if (!ua.includes('compatible') || ua.match(/bot|crawler|spider|scraper/i)) {
              result.isBot = true;
              result.botName = '크롤러 봇';
              result.isBotDangerCountry = false;
              return result;
            }
          }
          
          // 일반 브라우저 파싱
          if (userAgent.includes('Chrome/')) {
            const chromeMatch = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
            if (chromeMatch) {
              result.browser = `Chrome ${chromeMatch[1]}`;
            } else {
              const chromeMatch2 = userAgent.match(/Chrome\/(\d+)/);
              if (chromeMatch2) {
                result.browser = `Chrome ${chromeMatch2[1]}`;
              } else {
                result.browser = 'Chrome';
              }
            }
          } else if (userAgent.includes('Firefox/')) {
            const firefoxMatch = userAgent.match(/Firefox\/(\d+\.\d+)/);
            result.browser = firefoxMatch ? `Firefox ${firefoxMatch[1]}` : 'Firefox';
          } else if (userAgent.includes('Safari/') && !userAgent.includes('Chrome')) {
            const safariMatch = userAgent.match(/Version\/(\d+\.\d+)/);
            result.browser = safariMatch ? `Safari ${safariMatch[1]}` : 'Safari';
          } else if (userAgent.includes('Edge/')) {
            const edgeMatch = userAgent.match(/Edge\/(\d+)/);
            result.browser = edgeMatch ? `Edge ${edgeMatch[1]}` : 'Edge';
          } else if (userAgent.includes('Edg/')) {
            const edgeMatch = userAgent.match(/Edg\/(\d+)/);
            result.browser = edgeMatch ? `Edge ${edgeMatch[1]}` : 'Edge';
          } else if (userAgent.includes('Opera/') || userAgent.includes('OPR/')) {
            const operaMatch = userAgent.match(/(?:Opera|OPR)\/(\d+\.\d+)/);
            result.browser = operaMatch ? `Opera ${operaMatch[1]}` : 'Opera';
          } else {
            result.browser = 'Unknown Browser';
          }
          
          // OS 파싱
          if (userAgent.includes('Windows NT 10.0')) {
            result.os = 'Windows 10';
          } else if (userAgent.includes('Windows NT 11.0')) {
            result.os = 'Windows 11';
          } else if (userAgent.includes('Windows NT 6.3')) {
            result.os = 'Windows 8.1';
          } else if (userAgent.includes('Windows NT 6.2')) {
            result.os = 'Windows 8';
          } else if (userAgent.includes('Windows NT 6.1')) {
            result.os = 'Windows 7';
          } else if (userAgent.includes('Mac OS X')) {
            const macMatch = userAgent.match(/Mac OS X (\d+[._]\d+[._]\d+)/);
            if (macMatch) {
              const version = macMatch[1].replace(/_/g, '.');
              result.os = `macOS ${version}`;
            } else {
              result.os = 'macOS';
            }
          } else if (userAgent.includes('Linux')) {
            result.os = 'Linux';
          } else if (userAgent.includes('Android')) {
            const androidMatch = userAgent.match(/Android (\d+\.\d+)/);
            result.os = androidMatch ? `Android ${androidMatch[1]}` : 'Android';
          } else if (userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod')) {
            const iosMatch = userAgent.match(/OS (\d+[._]\d+)/);
            if (iosMatch) {
              const version = iosMatch[1].replace(/_/g, '.');
              result.os = `iOS ${version}`;
            } else {
              result.os = 'iOS';
            }
          } else {
            result.os = 'Unknown OS';
          }
          
          return result;
        } catch (error) {
          console.error('User Agent 파싱 오류:', error);
          return null;
        }
      },
    },
  }
  </script>
  
  <template>
    <div v-show="weblogList" class="rounded shadow">
      <div class="p-4 border-bottom">
        <h5 class="text-md-left text-center">방문객 접속기록 통계</h5>
        <p class="text-md-left text-center font-size-12">중국,싱가포르에서의 접속은 불법봇으로 감지하여 404에러 페이지로 보내서 방어중입니다.</p>
        <p class="text-md-left text-center font-size-12">구글,네이버 등의 검색엔진 봇은 정상적인 행위이나 통계에는 제외하고 실사용자만 통계에 집계합니다.</p>
        
        <!-- 최근 7일간 접속 통계 -->
        <div class="row mt-3 mb-4">
          <div class="col-12">
            <div class="card bg-light">
              <div class="card-body">
                <h6 class="card-title text-center mb-2">최근 일주일간 접속 통계 (봇제외)</h6>
                <span class="text-center font-size-14 mb-3">
                  합계: <b class="text-primary h4">{{ totalVisitorCount }}</b>명 <br>
                  모바일환경때문에 중복 있을 수 있습니다.
                </span>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered table-hover mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th class="text-center font-size-12" v-for="stat in dailyVisitorStats" :key="stat.day">
                          {{ stat.day }}</br>
                          <span class="font-size-10">{{ stat.date.split('-').join('.') }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center font-weight-bold" v-for="stat in dailyVisitorStats" :key="stat.day">
                          {{ stat.count }}명
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div>
          <div class="row mt-4">
  
            <div class="col-12 pt-2">
              <div class="rounded shadow">
  
                <div class="">
                  <div class="table table-sm table-responsive font-size-14 text-dark">
                    <b-table 
                      id="cordingHistoryTable" 
                      ref="cordingHistoryTable" 
                      :fields="fields" 
                      :items="weblogList" 
                      :hover="true"
                      :tbody-tr-class="getRowClass"
                      table-class="text-center">
                      <!-- 번호 -->
                      <template #cell(idx)="row">
                        <div class="font-size-10">
                          {{ row.item.idx }}
                        </div>
                      </template>
                      <!-- IP주소 -->
                      <template #cell(ip)="row">
                        <div class="font-size-10">
                          {{ row.item.ip }}
                        </div>
                      </template>
                      <!-- 행동횟수 -->
                      <template #cell(queryNum)="row">
                        <div class="font-size-10">
                          {{ row.item.queryNum }}
                        </div>
                      </template>
                      <!-- 날짜 -->
                      <template #cell(today)="row">
                        <div class="font-size-10">
                          {{ row.item.today }}
                        </div>
                      </template>
                      <!-- 접속시간 -->
                      <template #cell(time)="row">
                        <div class="font-size-10">
                          {{ row.item.time }}
                        </div>
                      </template>
                      <!-- 국가 -->
                      <template #cell(country)="row">
                        <div v-if="row.item.country" class="font-size-10">
                          <!-- countryCode, region, city, isp-->
                          <div class="mt-1 p-2 bg-light rounded font-size-10 text-left">
                            <span v-if="row.item.country=='South Korea'" class="font-weight-bold">
                              한국
                            </span>
                            <span v-else-if="row.item.country=='Unknown'" class="text-muted">알수없음</span>
                            <span v-else class="text-danger">{{ row.item.country }} </span>
                            <span v-if="row.item.region" class="font-weight-bold mr-1">{{ row.item.region }},</span>
                            <span v-if="row.item.isp" class="mr-1">{{ row.item.isp }}</span>
                          </div>
                        </div>
                      </template>
                      <!-- (isBotDangerCountry 값이 true라면 중국,싱가포르에서의 접속이고) (isBot 값이 true라면 악성봇이고) (searchBotName이 빈값이 아니면 검색봇) (isBot 값이 false면 사용자) -->
                      <template #cell(isUser)="row">
                        <div class="font-size-11">
                          <div v-if="row.item.isBotDangerCountry" class="badge badge-danger">
                            <i class="mdi mdi-earth"></i>중국,싱가포르
                          </div>
                          <div v-else-if="row.item.isBot" class="badge badge-danger">
                            <i class="mdi mdi-robot"></i>봇
                          </div>
                          <div v-else-if="row.item.searchBotName != ''" class="badge badge-info">
                            <i class="mdi mdi-robot"></i>{{ row.item.searchBotName }}
                          </div>
                          <div v-else class="badge badge-light font-size-11">
                            <i class="mdi mdi-account"></i>
                          </div>
                        </div>
                      </template>
                      <!-- 헤더정보 -->
                      <template #cell(headers)="row">
                        <div class="font-size-10">
                          <div v-if="parseUserAgent(row.item.headers)">
                            <details class="text-muted" style="cursor: pointer;">
                              <summary class="font-size-10">헤더 보기</summary>
                              <div class="mt-1 p-2 bg-light rounded font-size-10 text-left" style="word-break: break-all;">
                                {{ row.item.headers }}
                              </div>
                            </details>
                          </div>
                          <div v-else class="text-muted font-size-10">
                            {{ row.item.headers || '-' }}
                          </div>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>